var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.$store.state.event.data.passages_inter.points),function(point,index){return _c('div',{key:index,staticClass:"container_button_passage"},[(point.display === 'true')?_c('b-button',{staticClass:"button_passage",class:{
      isCurrent: _vm.$store.state.event.selection.passage === point.name,
    }},[_c('router-link',{attrs:{"target":"_self","to":{
        name: 'Epreuve',
        query: { id: _vm.$store.state.event.id, p: _vm.$store.state.event.selection.course, i: point.name },
      },"refresh":""}},[_vm._v(_vm._s(point.name))])],1):_vm._e()],1)}),_vm._v(" "),_c('div',{staticClass:"container_button_passage"},[_c('b-button',{staticClass:"button_passage",class:{
      isCurrent: _vm.$store.state.event.selection.passage === '',
    }},[_c('router-link',{attrs:{"target":"_self","to":{
        name: 'Epreuve',
        query: { id: _vm.$store.state.event.id, p: _vm.$store.state.event.selection.course },
      },"refresh":""}},[_vm._v("Arrivée")])],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }